import React, { useEffect, useState } from "react";
import "./TrialBalance.css";
import { FileSpreadsheet } from "lucide-react";
import { toast } from "react-toastify";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";

const TrialBalance = () => {
    const [trialBalance, setTrialBalance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

    useEffect(() => {
    const fetchTrialBalance = async () => {

      try {
        setLoading(true);

        const res = await axios.get(
          "https://payyug.in/api/report/trial-balance",
          { params: { 
            superAdminId:profile?.superAdminId,
            branchId:profile?.branchId
           } }
        );

        // console.log("trial balance:",res.data)
        setTrialBalance(res.data?.data || []);
        setTotalDebit(res.data?.totalDebit || 0);
        setTotalCredit(res.data?.totalCredit || 0);
      } catch (err) {
        toast.error(
          err.response?.data?.message || "Failed to fetch trial balance"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchTrialBalance();
  }, [profile]);
  return (
    <>
      <div className="trialbalance-container">
      {/* Page Title */}
      <h1 className="trialbalance-title">Trial Balance</h1>

      {/* Filter Section */}
      {/* <div className="trialbalance-filterBox">
        <div className="trialbalance-filter-title">Filter By</div>
        <div className="trialbalance-filter-item-div">
          <div className="trialbalance-filter-item">
            <label>Branch</label>
            <select>
              <option value="">Select Branch</option>
              <option value="Bareilly">Bareilly</option>
              <option value="Delhi">Delhi</option>
              <option value="Mumbai">Mumbai</option>
            </select>
          </div>

          <button className="trialbalance-filter-btn">Filter</button>
        </div>
      </div> */}

      {/* Reports */}
       <div className="trialbalance-report-section">
          <div className="trialbalance-report-top">
            {/* <h2>Latest Orders</h2> */}
            <button className="trialbalance-export-btn">
            <FileSpreadsheet size={15} /> Export
          </button>
          </div>

          <div className="trialbalance-report-table">
            <table>
              <thead>
                <tr>
                <th>Ledger ID</th>
                <th>Ledger Name</th>
                <th>Total Debit</th>
                <th>Total Credit</th>
              </tr>
              </thead>

              <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" align="center">
                    Loading...
                  </td>
                </tr>
              ) : trialBalance.length > 0 ? (
                trialBalance.map((item) => (
                  <tr key={item.ledgerId}>
                    <td>{item.ledgerId}</td>
                    <td>{item.ledger?.name || "-"}</td>
                    <td className="trialbalance-debit-text">
                      ₹{item.totalDebit || 0}
                    </td>
                    <td className="trialbalance-credit-text">
                      ₹{item.totalCredit || 0}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" align="center">
                    No Records Found
                  </td>
                </tr>
              )}

              {!loading && trialBalance.length > 0 && (
                <tr className="trialbalance-totalRow">
                  <td colSpan="2"><strong>Total</strong></td>
                  <td className="trialbalance-debit-text">
                    <strong>₹{totalDebit}</strong>
                  </td>
                  <td className="trialbalance-credit-text">
                    <strong>₹{totalCredit}</strong>
                  </td>
                </tr>
              )}
            </tbody>
            </table>
          </div>
        </div>
    </div>
    </>
  )
}

export default TrialBalance
